import { NumberInput } from '@mantine/core';
import { IUserAbsences } from '../../../hooks/promises/getUserAbsences';
import CommonButton from '../../../components/CommonButton';

interface INumberOfAbsencesStaticProps {
  userAbsences: IUserAbsences | null;
  setEditing: React.Dispatch<React.SetStateAction<boolean>>;
  thisMonthYear: string;
}

function NumberOfAbsencesStatic({
  userAbsences,
  setEditing: setEditingNumberOfAbsences,
  thisMonthYear,
}: INumberOfAbsencesStaticProps) {
  return (
    <div className="flex flex-col items-end gap-4">
      <NumberInput
        className="w-full"
        label={`${thisMonthYear}: Number of Absences`}
        size="lg"
        placeholder={userAbsences?.daysOfAbsence.toString()}
        disabled
      />
      <div title="Edit absences for the current month">
        <CommonButton
          text="Edit"
          variant="filled"
          className="px-4 py-2 text-sm w-fit h-fit"
          onClick={() => setEditingNumberOfAbsences(true)}
        />
      </div>
    </div>
  );
}

export default NumberOfAbsencesStatic;
